import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
import index from '@/components/index'
import member from '@/components/member'
import committee from '@/components/committee'
import programme from '@/components/programme'
import about_us from '@/components/about_us'
import join_us from '@/components/join_us'
import contact_us from '@/components/contact_us'
import opinion from '@/components/opinion'
import calendar from '@/components/calendar'
import comm_article from '@/components/comm_article'
import article from '@/components/article'
import search from '@/components/search'

Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [{
		path: '/',
		redirect: '/index'
	}, {
		path: '/',
		name: 'home',
		component: home,
		children: [{
			path: '/index',
			component: index,
			meta: {
				title: 'Home • “一带一路”生命科技促进联盟',
				keepAlive: false,
			}
		}, {
			path: '/member',
			component: member,
			meta: {
				title: '会员信息 • “一带一路”生命科技促进联盟',
				keepAlive: false,
			}
		}, {
			path: '/committee',
			component: committee,
			meta: {
				title: '标准化委员会 • “一带一路”生命科技促进联盟',
				keepAlive: false,
			}
		}, {
			path: '/comm_article/:id',
			name: 'comm_article',
			component: comm_article,
			meta: {
				title: '',
				keepAlive: false,
			}
		}, {
			path: '/programme',
			component: programme,
			meta: {
				title: '规划与进展 • “一带一路”生命科技促进联盟',
				keepAlive: false,
			}
		}, {
			path: '/article/:id',
			name: 'article',
			component: article,
			meta: {
				title: '',
				keepAlive: false,
			}
		}, {
			path: '/programme/:search',
			name: 'search',
			component: search,
			meta: {
				title: '搜索结果 • “一带一路”生命科技促进联盟',
				keepAlive: false,
			}
		}, {
			path: '/about_us',
			component: about_us,
			meta: {
				title: '关于我们 • “一带一路”生命科技促进联盟',
				keepAlive: false,
			}
		}, {
			path: '/join_us',
			component: join_us,
			meta: {
				title: '加入我们 • “一带一路”生命科技促进联盟',
				keepAlive: false,
			}
		}, {
			path: '/contact_us',
			component: contact_us,
			meta: {
				title: '联系我们 • “一带一路”生命科技促进联盟',
				keepAlive: false,
			}
		}, {
			path: '/opinion',
			component: opinion,
			meta: {
				title: '意见调查 • “一带一路”生命科技促进联盟',
				keepAlive: false,
			}
		}, {
			path: '/calendar',
			component: calendar,
			meta: {
				title: '事件日历 • “一带一路”生命科技促进联盟',
				keepAlive: false,
			}
		}]
	}]
})


// WEBPACK FOOTER //
// ./src/router/index.js